import PropTypes from 'prop-types';
import Icon from '../Icon/Icon';

const AddressCardText = (props) => {
  const { 
    location = {},
    serviceAreaText = null,
    className = '',
    iconColor = 'dark-grey',
  } = props;
  const icon = serviceAreaText ? 'Radar' : 'MapPin';
  const title = serviceAreaText || location.displayName;
  const text = serviceAreaText || `${location.displayName} (${location.distance})`;

  return (
    <div
      className={className}
    >
      <div className="flex items-center text-sm text-text-blue">
        <Icon
          className="mr-2"
          color={iconColor}
          icon={icon}
        />
        <p title={title}>
          {text}
        </p>
      </div>
    </div>
  );
}

AddressCardText.propTypes = {
  /** className */
  className: PropTypes.string,
  /** location object via displayName and distance */
  location: PropTypes.shape({
    displayName: PropTypes.string,
    distance: PropTypes.string,
  }),
  /** icon color */
  iconColor: PropTypes.string,
  /** text describing the service area */
  serviceAreaText: PropTypes.string,
};

export default AddressCardText;
